export enum DeviceSignal {
  EXCELLENT = 'Excellent',
  VERY_GOOD = 'Very Good',
  GOOD = 'Good',
  LOW = 'Low',
  VERY_LOW = 'Very Low',
  BLUETOOTH = 'Bluetooth',
  SUB_DEVICE = 'Sub-Device'
}
